import { inject, type InjectionKey } from 'vue'
import type { ShowAddCurrencyDialogParams } from '../modals/CurrencyModalAdd.vue'
import type { ShowCurrencyDetailsDialogParams } from '../modals/CurrencyModalDetails.vue'
import type { ShowRemoveCurrencyDialogParams } from '../modals/CurrencyModalRemove.vue'

/**
 * Injection contract for the currency modals. Kept in this dedicated leaf
 * module — not in the `providers/index.ts` barrel — so `CurrenciesModalProvider`
 * and the modals can import the key/hook without forming a barrel↔member
 * import cycle.
 */
export interface CurrenciesModalsContext {
  showAddCurrency: (params: ShowAddCurrencyDialogParams) => void
  showCurrencyDetails: (params: ShowCurrencyDetailsDialogParams) => void
  showRemoveCurrency: (params: ShowRemoveCurrencyDialogParams) => void
}

export const currenciesModalsKey = Symbol(
  'currencies-modals'
) as InjectionKey<CurrenciesModalsContext>

export function useCurrenciesModals() {
  return inject(currenciesModalsKey)
}
